(() => {
  'use strict';
  const configNode = document.getElementById('fa-quick-add-config');
  if (!configNode || window.FAQuickAdd) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.labels;
  const root = config.root;
  const selector = '[data-fa-qa]';
  const icon = '<svg viewBox="0 0 37 40" aria-hidden="true" focusable="false"><path fill="currentColor" d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"/></svg>';
  const panel = document.createElement('div');
  panel.id = 'fa-qa-options';
  panel.className = 'fa-qa-options';
  panel.hidden = true;
  panel.setAttribute('role', 'region');
  const status = document.createElement('div');
  status.className = 'fa-qa-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  document.body.append(panel, status);
  let active = null;
  let loading = false;
  let adding = false;
  let generation = 0;

  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: config.currency
  }).format(cents / 100);
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const isDiamond = type => /diamond painting|broderie diamant/i.test(type);
  const isPbn = type => /paint by numbers|peinture par numéros|malen nach zahlen|dipingere con i numeri/i.test(type);
  const customProduct = (handle, template, tags) => /custom|personalized|personalised/i.test(handle + ' ' + template + ' ' + tags);

  function announce(message) {
    status.textContent = message;
  }

  function syncCount(cart) {
    if (!cart || !Number.isInteger(cart.item_count)) return;
    const bubble = document.getElementById('CartCount');
    if (!bubble) return;
    bubble.classList.toggle('hide', cart.item_count === 0);
    const count = bubble.querySelector('[data-cart-count], span:first-child');
    if (count) count.textContent = String(cart.item_count);
  }

  window.addEventListener('section-store:cart:ready', event => syncCount(event.detail?.cart));
  window.addEventListener('section-store:cart:updated', event => syncCount(event.detail?.cart));

  function inlineProduct(card) {
    try {
      const options = JSON.parse(card.dataset.faOptions || 'null');
      if (!options || !Array.isArray(options.variants) || !options.variants.length) return null;
      if (!options.variants.every(variant => Number.isSafeInteger(variant.id) && variant.id > 0 && typeof variant.title === 'string' && Number.isFinite(variant.price) && variant.price >= 0 && typeof variant.available === 'boolean')) return null;
      return { handle: card.dataset.faHandle, title: card.dataset.faTitle, type: card.dataset.faType, variants: options.variants, requires_selling_plan: options.requires_selling_plan };
    } catch {
      return null;
    }
  }

  function close(restoreFocus = false) {
    generation += 1;
    const previous = active;
    active = null;
    loading = false;
    panel.hidden = true;
    panel.replaceChildren();
    if (previous) {
      previous.setAttribute('aria-expanded', 'false');
      previous.removeAttribute('aria-busy');
      if (restoreFocus && previous.isConnected) previous.focus();
    }
  }

  function position() {
    if (!active || !active.isConnected) return close();
    const rect = active.getBoundingClientRect();
    const width = Math.min(310, window.innerWidth - 24);
    const height = Math.min(panel.scrollHeight, window.innerHeight * 0.65);
    const left = Math.max(12, Math.min(rect.right - width, window.innerWidth - width - 12));
    let top = rect.bottom + 8;
    if (top + height > window.innerHeight - 12 && rect.top - height - 8 >= 12) top = rect.top - height - 8;
    panel.style.width = width + 'px';
    panel.style.left = left + 'px';
    panel.style.top = Math.max(12, Math.min(top, window.innerHeight - height - 12)) + 'px';
  }

  function moreOptions(handle) {
    const link = document.createElement('a');
    link.className = 'fa-qa-choice fa-qa-more';
    link.href = productUrl(handle);
    link.textContent = text.moreOptions + ' →';
    return link;
  }

  function showMessage(message, handle) {
    const messageNode = document.createElement('p');
    messageNode.className = 'fa-qa-message';
    messageNode.textContent = message;
    panel.replaceChildren(messageNode, moreOptions(handle));
    position();
  }

  function variantLabel(product, variant) {
    let label = variant.title === 'Default Title' ? text.add : variant.title;
    if (/^mini/i.test(product.title) && !/\d/.test(label)) {
      const dimensions = product.title.match(/\d+(?:\.\d+)?["″]?\s*[x×]\s*\d+(?:\.\d+)?["″]?(?:\s*\([^)]*\))?/i);
      if (dimensions) label = dimensions[0] + ' · ' + label.replace(/^Full Kit\s*-\s*/i, '');
    }
    return label;
  }

  function showVariants(product, focusFirst = false) {
    panel.replaceChildren();
    const variants = isPbn(product.type) ? product.variants.slice(0, 3) : product.variants;
    for (const variant of variants) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fa-qa-choice';
      button.dataset.variantId = String(variant.id);
      button.disabled = !variant.available;
      const name = document.createElement('span');
      name.textContent = variantLabel(product, variant);
      const price = document.createElement('strong');
      price.textContent = money(variant.price);
      button.append(name, price);
      if (!variant.available) {
        const soldOut = document.createElement('small');
        soldOut.textContent = text.soldOut;
        name.append(document.createElement('br'), soldOut);
      }
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        add(product, variant, button);
      });
      panel.append(button);
    }
    panel.append(moreOptions(product.handle));
    position();
    if (focusFirst) panel.querySelector('button:not(:disabled), a')?.focus({ preventScroll: true });
  }

  async function add(product, variant, source) {
    if (adding || !variant.available) return;
    adding = true;
    const trigger = active;
    const originalText = source.textContent;
    source.disabled = true;
    source.setAttribute('aria-busy', 'true');
    if (source !== trigger) source.textContent = text.adding;
    for (const button of panel.querySelectorAll('button')) button.disabled = true;
    announce(text.adding);
    let accepted = false;
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400) {
        const failure = new Error(text.addError);
        failure.customerMessage = typeof result.description === 'string' ? result.description : (typeof result.message === 'string' ? result.message : text.addError);
        throw failure;
      }
      accepted = true;
      close();
      announce(text.added.replace('[product]', product.title));
      if (typeof window.SectionStoreCart?.getCart !== 'function') {
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (cartResponse.ok) syncCount(await cartResponse.json());
      }
    } catch (error) {
      if (accepted) {
        announce(text.added.replace('[product]', product.title));
      } else {
        const messageText = error.customerMessage || text.addError;
        announce(messageText);
        const card = trigger?.closest(selector);
        if (card) delete card.dataset.faOptions;
        if (active === trigger && !panel.hidden) {
          showVariants(product);
          const message = document.createElement('p');
          message.className = 'fa-qa-message fa-qa-error';
          message.setAttribute('role', 'alert');
          message.textContent = messageText;
          panel.prepend(message);
          position();
        }
      }
    } finally {
      adding = false;
      source.removeAttribute('aria-busy');
      source.disabled = false;
      if (source !== trigger && source.isConnected) source.textContent = originalText;
      if (trigger) trigger.removeAttribute('aria-busy');
    }
  }

  async function open(trigger, card) {
    if (adding) return;
    if (active === trigger) return close(true);
    close();
    active = trigger;
    let product = inlineProduct(card);
    loading = !product;
    const request = generation;
    const handle = card.dataset.faHandle;
    trigger.setAttribute('aria-expanded', 'true');
    if (loading) trigger.setAttribute('aria-busy', 'true');
    panel.setAttribute('aria-label', text.choose.replace('[product]', card.dataset.faTitle || handle));
    panel.hidden = false;
    if (loading) showMessage(text.loading, handle);
    try {
      if (!product) {
        const response = await fetch(productUrl(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error(text.loadError);
        product = await response.json();
      }
      if (request !== generation || active !== trigger) return;
      loading = false;
      trigger.removeAttribute('aria-busy');
      if (isDiamond(product.type) || customProduct(product.handle, product.template_suffix || '', product.tags || [])) {
        window.location.assign(productUrl(handle));
        return;
      }
      if (product.requires_selling_plan) return showMessage(text.moreOptions, handle);
      if (product.variants.length === 1 && product.variants[0].available) {
        showMessage(text.adding, handle);
        return add(product, product.variants[0], trigger);
      }
      showVariants(product, true);
    } catch (error) {
      if (request !== generation || active !== trigger) return;
      loading = false;
      trigger.removeAttribute('aria-busy');
      showMessage(text.loadError, handle);
      announce(text.loadError);
    }
  }

  function enhance(scope) {
    const cards = [];
    if (scope.matches?.(selector)) cards.push(scope);
    cards.push(...(scope.querySelectorAll?.(selector) || []));
    for (const card of cards) {
      if (card.querySelector('.fa-qa-trigger') || !card.dataset.faHandle || isDiamond(card.dataset.faType || '')) continue;
      const image = card.querySelector('.grid-view-item__image-wrapper, .list-view-item__image-wrapper');
      if (!image) continue;
      image.classList.add('fa-qa-image');
      const custom = card.dataset.faCustom === 'true' || customProduct(card.dataset.faHandle, '', '');
      const trigger = document.createElement(custom ? 'a' : 'button');
      trigger.className = 'fa-qa-trigger';
      trigger.innerHTML = icon;
      const title = card.dataset.faTitle || card.querySelector('.grid-view-item__title, .list-view-item__title')?.textContent.trim() || card.dataset.faHandle;
      trigger.setAttribute('aria-label', (custom ? text.customize : text.choose).replace('[product]', title));
      if (custom) {
        trigger.href = productUrl(card.dataset.faHandle);
      } else {
        trigger.type = 'button';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', panel.id);
        trigger.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          open(trigger, card);
        });
      }
      image.append(trigger);
    }
  }

  document.addEventListener('pointerdown', event => {
    if (active && !panel.contains(event.target) && !active.contains(event.target)) close();
  }, true);
  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(true); }
    if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && !loading) {
      const options = [...panel.querySelectorAll('button:not(:disabled), a')];
      if (!options.length) return;
      event.preventDefault();
      const index = options.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown' ? (index + 1) % options.length : (index < 1 ? options.length - 1 : index - 1);
      options[next].focus();
    }
  });
  document.addEventListener('focusin', event => {
    if (active && event.target !== active && !panel.contains(event.target)) close();
  });
  window.addEventListener('resize', position);
  document.addEventListener('scroll', event => {
    if (active && !panel.contains(event.target)) close();
  }, true);
  const content = document.getElementById('MainContent') || document.body;
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) enhance(node);
    if (active && !active.isConnected) close();
  }).observe(content, { childList: true, subtree: true });
  enhance(content);
  window.FAQuickAdd = { version: '1.1.0', refresh: () => enhance(content) };
})();
